import { Button, Card, Group, Image, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { Dashboard } from "./Dashboard";

export function TiendasViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {
    const dashboard = entity as Dashboard;

    const tienda_id = record[0] as string;
    const nombre = record[2] as string;
    const visitas = record[6] as string;

    const image_src = getGoogleMapsStreetViewImage(position, 350, 200, 150);

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    {group.records.map(
                        ({ recordValue: rec }, index) => {
                            const g_title = `${rec[2]}`;
                            const g_tienda_id = rec[0] as string;
                            
                            return (<Stack key={`grp_${g_tienda_id}`}>
                                <Title order={5}>{index + 1}: {g_title}</Title>
                            </Stack>)
                        }
                    )
                    }
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {

        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    <Title order={4}>{`${nombre}`}</Title>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">
                            Visitas:
                            {visitas.split('--').map((line, index) => (
                                <Text key={index}>{line}</Text>
                            ))}
                        </Text>    
                    </Group>
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleExecuteAction(
                                dashboard.def.clientActions.ACTVerPersonalTienda,
                                [{ 'c_tienda_id': tienda_id }]
                            )
                        }} >Ver Personal</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}